const BG =
  "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&q=85";

import { FREE_URL } from "../../lib/checkoutLinks";

export const FinalCTA = () => (
  <section className="relative py-16 md:py-24 px-6 overflow-hidden">
    <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: `url(${BG})` }} />
    <div className="absolute inset-0 bg-[#0A0A0B]/80" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#C6FF3D]/20 rounded-full blur-[120px] animate-forge-glow" />
    <div className="relative max-w-3xl mx-auto text-center">
      <h2 className="font-display text-4xl sm:text-6xl text-white mb-8 leading-tight">
        YOUR PLAN IS <span className="text-[#C6FF3D]">60 SECONDS</span> AWAY.
      </h2>
      <a
        href={FREE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="final-cta-button"
        className="tap-target inline-flex items-center justify-center bg-[#C6FF3D] text-black font-semibold px-10 py-4 rounded-full text-lg hover:scale-105 hover:shadow-[0_0_40px_rgba(198,255,61,0.6)] transition-all duration-300"
      >
        Start My Free Plan
      </a>
    </div>
  </section>
);
